import JQuery from "jquery";
window.jQuery = window.$ = JQuery;
window.Swiper = require('swiper/bundle').default;
window.bootstrap = require('bootstrap');
